<div [class.error]="hasError" [class.transparent]="transparent">
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="stretch-input"
    [class.filter-mode-margin]="filterMode"
  >
    <mat-chip-list #chipList aria-label="selection" [disabled]="disabled">
      <mat-chip *ngFor="let item of selectedItems" (removed)="remove(item)">
        <div [class.ellipsis-text]="item.name.length > 40" [matTooltip]="item.name.length > 40 ? item.name : ''">
          {{ item.name }}
        </div>
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
      <input
        matInput
        forbidAngleBrackets
        [placeholder]="placeholder"
        #input
        [formControl]="formCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        *ngIf="!disabled && !readonly"
        attr.aria-labelledby="{{ ariaLabelledby }}"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <div *ngIf="items.length > 0">
        <div *ngFor="let item of filteredItems | async">
          <mat-option
            *ngIf="!item.selected"
            [value]="item"
            (click)="$event.stopPropagation()"
            matTooltip="{{ item.name }}"
            matTooltipShowDelay="300"
          >
            <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
            <span>{{ item.name }}</span>
          </mat-option>
        </div>
      </div>
    </mat-autocomplete>
  </mat-form-field>
  <mat-error class="mat-error-multiselect" *ngIf="!filterMode && required">
    {{ errorMessage }}
  </mat-error>
</div>
